define((require) => {
    "use strict";

    var EmbedWidgetModel = require("shared/ui/experience/widgets/embedWidget/EmbedWidgetModel");

    /**
     * @class {EmbedWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return EmbedWidgetModel.mixin("EmbedWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function() {
            return this.get("url")
                ? `Embed: ${this.get("url")}`
                : null;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/embedWidget/EmbedWidgetModelEditorMixin.js